var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[[_c('list-group',{attrs:{"title":'消耗品について'}},[_c('list-item',{attrs:{"spanText":'Q. ',"text":'ベルトを交換したい',"urlName":'Help35'}})],1)]],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-253fc136","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HelpCategory32.vue
// module id = hm/v
// module chunks = 0